import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ResourceService } from 'src/app/services/resource/resource.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-media-file',
  templateUrl: './media-file.component.html',
  styleUrls: ['./media-file.component.css']
})
export class MediaFileComponent implements OnInit {


  Submitted: boolean = false;
  ResourceList:any;

  @ViewChild('fileUploader', { static: false }) fileUploader: ElementRef;

  constructor(private resourceService: ResourceService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService,
     private _sanitizer: DomSanitizer) { }


  ResourceModel = {
    ResourceID:0,
    ResourceType:'0',
    ResourceName:'',
    ResourceHeight:0,
    ResourceWidth:0,
    MediaType:'0',
    ResourcePath:'',
    IsActive: true,   
  };

  ClearResource() {
    this.Submitted = false;  
    this.ResourceModel.ResourceType = '0';
    this.ResourceModel.ResourceID = 0;
    this.ResourceModel.ResourceHeight = 0;
    this.ResourceModel.ResourceWidth = 0;
    this.ResourceModel.MediaType='0';
    this.ResourceModel.ResourceName='';
    this.ResourceModel.ResourcePath='';
    if(this.SelectedFileForUpload!=undefined && this.SelectedFileForUpload!=null)
    this.fileUploader.nativeElement.value = null;
  };

 ResourceMarkActive(obj) {
    this.ResourceModel.ResourceID = obj.ResourceID;
    this.ResourceModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.resourceService.ResourceMarkActive( this.ResourceModel.ResourceID, this.ResourceModel.IsActive).subscribe((data: any) => {
      this.spinnerService.hide();
      this.GetAllResource();
      this.globalHelper.CheckActionStatus(data);
    });
  }

  SelectedFileForUpload: any;
  getFileDetails(file) {
    this.SelectedFileForUpload = file[0];
  };

  validation() {
    return this.ResourceModel.ResourceType == '0';
  }

  SaveResource(valid) {
    this.Submitted = true;
    if (valid && !this.validation()) {
      this.spinnerService.show();
      this.resourceService.SaveResource(JSON.stringify(this.ResourceModel),this.SelectedFileForUpload).subscribe((data: any) => {
       
        this.spinnerService.hide();
        if(data.webResponse.Status && this.ResourceModel.ResourceID==0){
          this.ClearResource();
         }
        if(data.webResponse.Status){
          if(this.SelectedFileForUpload!=undefined && this.SelectedFileForUpload!=null)
          this.fileUploader.nativeElement.value = null;
          this.GetAllResource();
        }
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  SearchModel={
    ResourceType:'0',
    MediaType:'0'
  }
  ClearSearch(){
    this.SearchModel.ResourceType='0';
    this.SearchModel.MediaType='0';
    this.ResourceList=[];
  }

  GetAllResource() {
    this.resourceService.GetAllResource(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.ResourceList = data.ResourceList;
      if (this.ResourceList != null) {
        for (var i = 0; i < this.ResourceList.length; i++) {
          if (this.ResourceList[i].MediaType=='YOUTUBE') {
          this.ResourceList[i].YouTubeUrls = this._sanitizer.bypassSecurityTrustResourceUrl(this.ResourceList[i].YouTubeUrls);
          }
        }

      }
    });

  }

  EditResource(obj) {
   
    this.ResourceModel.ResourceType = obj.ResourceType;
    this.ResourceModel.ResourceID = obj.ResourceID;
    this.ResourceModel.ResourceName = obj.ResourceName;
    this.ResourceModel.ResourceHeight = obj.ResourceHeight;
    this.ResourceModel.ResourceWidth = obj.ResourceWidth;
    this.ResourceModel.ResourcePath = obj.ResourcePath;
    this.ResourceModel.MediaType = obj.MediaType;
    this.ResourceModel.IsActive = obj.IsActive;

  };

  ngOnInit() {
   this.GetAllResource();
  }

  PackageList=[];
  GetAllPackage() {

    this.LookupService.GetLookupsList('PackageForMatrix', '').subscribe((data: any) => {
      this.PackageList = data.LookupItems;
    });
  }

  

}

